/**
 * @generated SignedSource<<7934854b6501dba15f834702a7357091>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserAvatar_User$data = {
  readonly avatarUrl: string | null | undefined;
  readonly name: string | null | undefined;
  readonly profile: {
    readonly slug: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"chat_useIsOnline">;
  readonly " $fragmentType": "UserAvatar_User";
};
export type UserAvatar_User$key = {
  readonly " $data"?: UserAvatar_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAvatar_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "chat_useIsOnline"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6d841bd62523320e5286e4dcbded7f99";

export default node;
